import { Routes } from '@angular/router';
import { canDeactivateFormFn } from '@core/guards';
import { themeResolverFn } from './resolvers/theme.resolver';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./components/theme-list/theme-list.component').then(
				(component) => component.ThemeListComponent
			)
	},
	{
		path: ':themeId',
		canDeactivate: [
			(component, currentRoute, currentState, nextState) =>
				canDeactivateFormFn(component.form, {
					componentRef: component,
					nextState
				})
		],
		resolve: { value: themeResolverFn },
		data: { breadcrumb: (data: any) => data.value?.name },
		loadComponent: () =>
			import(
				'./components/theme-edition/theme-edition.component'
			).then((component) => component.ThemeEditionComponent)
	}
];
